<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>

    <div class="p-6 pb-0">
      <div class="flex flex-wrap items-end gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Anno</label>
          <input
            v-model.number="form.anno"
            type="number"
            min="2000"
            max="2100"
            class="p93__input w-28"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Settimana da</label>
          <input
            v-model.number="form.settimana_da"
            type="number"
            min="1"
            max="53"
            class="p93__input w-24"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Settimana a</label>
          <input
            v-model.number="form.settimana_a"
            type="number"
            min="1"
            max="53"
            class="p93__input w-24"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Cliente</label>
          <input
            v-model="form.cliente"
            type="text"
            placeholder="Codice o ragione sociale"
            class="p93__input w-56"
          />
        </div>
        <button
          @click="cerca"
          class="bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700"
        >
          Cerca
        </button>
        <button
          @click="resetFiltri"
          class="bg-gray-400 text-gray-700 px-5 py-2 rounded hover:bg-gray-300"
        >
          Reset
        </button>

        <div class="flex gap-2 ml-auto">
          
          <button
            v-if="selectedMail.length > 0"
            @click="azioneInviaMail"
            class="bg-green-600 text-white px-5 py-2 rounded hover:bg-green-700 flex items-center gap-2"
          >
            <span>Invia mail ({{ selectedMail.length }})</span>
          </button>
          <button
            v-if="selectedPercorsi.length > 0"
            @click="azioneCalcolaPercorsi"
            class="bg-purple-600 text-white px-5 py-2 rounded hover:bg-purple-700 flex items-center gap-2"
          >
            <span>Calcola percorso vettori ({{ selectedPercorsi.length }})</span>
          </button>
        </div>
      </div>

      <PageServerTable
        :headers="localHeaders"
        :items="righeOrdinate"
        :items-per-page="localIpp"
        :items-per-page-options="ippo"
        :sort-by="localSortby"
        :items-length="count"
        :reload-fn="reload"
        :page="localPage"
        show-current-page
      >
        <template #item.select_mail="{ item }">
          <input
            type="checkbox"
            :value="item.internalOrdNo"
            v-model="selectedMail"
            class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
        </template>

        <template #item.select_percorso="{ item }">
          <input
            type="checkbox"
            :value="item.internalOrdNo"
            v-model="selectedPercorsi"
            :disabled="item.imballato !== 'Si'"
            :title="item.imballato !== 'Si' ? 'Disponibile solo per ordini imballati' : ''"
            class="rounded border-gray-300 text-purple-600 focus:ring-purple-500 disabled:opacity-40 disabled:cursor-not-allowed"
          />
        </template>

        <template #item.internalOrdNo="{ item }">
          <Link
            :href="route('modules.pannello-di-controllo.ordine', { ordine: item.internalOrdNo })"
            class="font-medium text-blue-600 hover:text-blue-800 hover:underline"
          >
            {{ item.internalOrdNo }}
          </Link>
        </template>

        <template #item.companyname="{ item }">
          <div class="font-medium">{{ item.companyname }}</div>
          <div class="text-xs text-gray-400">{{ item.Customer }}</div>
        </template>

        <template #item.autorizzato="{ item }">
          <span
            :class="dotClass(item.autorizzato === 'Si' ? 2 : 0)"
            class="inline-block w-3 h-3 rounded-full"
            :title="item.autorizzato === 'Si' ? 'Autorizzato' : 'Bloccato'"
          />
        </template>

        <template #item.prelevato="{ item }">
          <span
            :class="dotClass(item.prelevato === 'Si' ? 2 : 0)"
            class="inline-block w-3 h-3 rounded-full"
            :title="item.prelevato === 'Si' ? 'Prelevato' : 'Da prelevare'"
          />
        </template>

        <template #item.prodottoAT="{ item }">
          <span
            :class="item.prodottoAT === 'Si' ? 'bg-orange-400' : 'bg-gray-200'"
            class="inline-block w-3 h-3 rounded-full"
            :title="item.prodottoAT === 'Si' ? 'Prodotto a terzista' : 'Produzione interna'"
          />
        </template>

        <template #item.imballato="{ item }">
          <span
            :class="dotClass(item.imballato === 'Si' ? 2 : 0)"
            class="inline-block w-3 h-3 rounded-full"
            :title="item.imballato === 'Si' ? 'Imballato' : 'Non imballato'"
          />
        </template>

        <template #item.memo="{ item }">
          <span class="text-xs text-gray-500 truncate max-w-xs block" :title="item.memo || item.NoteSede">
            {{ item.memo || item.NoteSede }}
          </span>
        </template>

        <template #item.vettore="{ item }">
          <span v-if="item.vettore" class="text-xs text-gray-500 truncate max-w-xs block" :title="item.vettore">
            {{ item.vettore }}
          </span>
          <span v-else class="text-xs text-red-500 truncate max-w-xs block" :title="'N/A'">
            N/A
          </span>
        </template>
      </PageServerTable>
    </div>

    <ToastNotification
      v-model:show="showToast"
      :message="toastMessage"
      :type="toastType"
    />
  </div>
</template>

<script>
import { router, Link } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Layout from '@/Layouts/Layout.vue';
import PageServerTable from '@/Components/PageServerTable.vue';
import ToastNotification from '@/Components/ToastNotification.vue';

export default {
  remember: 'form',
  components: {
    BreadCrumbs,
    Layout,
    PageServerTable,
    Link,
    ToastNotification
  },
  props: ['user', 'moduleSlug', 'righe', 'count', 'filtri', 'headers', 'sortby', 'ipp', 'ippo', 'page', 'flash'],
  data() {
    return {
      localHeaders: this.headers,
      localSortby: this.sortby,
      localIpp: this.ipp,
      localPage: this.page,
      selectedMail: [],
      selectedPercorsi: [],
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      form: {
        anno: this.filtri?.anno ?? new Date().getFullYear(),
        settimana_da: this.filtri?.settimana_da ?? this.currentIsoWeek(),
        settimana_a: this.filtri?.settimana_a ?? this.currentIsoWeek(),
        cliente: this.filtri?.cliente ?? '',
      },
    };
  },
  watch: {
    flash: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val?.error) {
          this.toastMessage = val.error;
          this.toastType = 'error';
          this.showToast = true;
        } else if (val?.message) {
          this.toastMessage = val.message;
          this.toastType = 'success';
          this.showToast = true;
        }
      }
    }
  },
  computed: {
    navigation() {
      return [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.' + this.moduleSlug), href: route('modules.home', this.moduleSlug) },
      ];
    },
    righeOrdinate() {
      return [...this.righe].sort((a, b) => {
        const aImballato = a.imballato === 'Si' ? 0 : 1;
        const bImballato = b.imballato === 'Si' ? 0 : 1;
        return aImballato - bImballato;
      });
    },
    internalOrdNoFilter() {
      return this.localHeaders.find(header => header.key === 'internalOrdNo')?.filtervalue ?? '';
    },
  },
  methods: {
    currentIsoWeek() {
      const now = new Date();
      const jan4 = new Date(now.getFullYear(), 0, 4);
      const startOfWeek1 = new Date(jan4);
      startOfWeek1.setDate(jan4.getDate() - ((jan4.getDay() + 6) % 7));
      return Math.ceil(((now - startOfWeek1) / 86400000 + 1) / 7);
    },
    cerca() {
      router.get(
        route('modules.pannello-di-controllo.home'),
        {
          anno: this.form.anno,
          settimana_da: this.form.settimana_da,
          settimana_a: this.form.settimana_a,
          cliente: this.form.cliente || undefined,
          internalOrdNo: this.internalOrdNoFilter || undefined,
        },
        { preserveState: false }
      );
    },
    resetFiltri() {
      this.form.anno = new Date().getFullYear();
      this.form.settimana_da = this.currentIsoWeek();
      this.form.settimana_a = this.currentIsoWeek();
      this.form.cliente = '';
      const orderHeader = this.localHeaders.find(header => header.key === 'internalOrdNo');
      if (orderHeader) orderHeader.filtervalue = '';
      this.cerca();
    },
    reload(sortby, itemsperpage, page) {
      if (sortby !== undefined) this.localSortby = sortby;
      if (itemsperpage !== undefined) this.localIpp = itemsperpage;
      if (page !== undefined) this.localPage = page;

      router.get(
        route('modules.pannello-di-controllo.home'),
        {
          ...this.form,
          internalOrdNo: this.internalOrdNoFilter || undefined,
          sortby: this.localSortby,
          itemsperpage: this.localIpp,
          page: this.localPage,
        },
        {
          preserveState: true,
          preserveScroll: true,
          only: ['righe', 'count', 'filtri', 'sortby', 'ipp', 'page'],
        }
      );
    },
    dotClass(stato) {
      if (stato === 2) return 'bg-green-500';
      if (stato === 1) return 'bg-yellow-400';
      return 'bg-red-500';
    },
    azioneInviaMail() {
      if (!confirm(`Inviare la mail standard per i ${this.selectedMail.length} ordini selezionati?`)) {
        return;
      }

      router.post(
        route('modules.pannello-di-controllo.invia-mail'),
        { ordini: this.selectedMail },
        {
          onSuccess: (page) => {
            this.selectedMail = [];
          },
          onError: (errors) => {
            alert('Errore durante l\'invio delle mail');
          },
        }
      );
    },
    azioneCalcolaPercorsi() {
      if (this.selectedPercorsi.length === 0) return;
      
      router.get(route('modules.percorsi-vettori.generazione-itinerari'), {
        selected_orders: this.selectedPercorsi
      });
    },
  },
};
</script>
